import { render, staticRenderFns } from "./adminSupportEmailModeration.vue?vue&type=template&id=24da48f2&scoped=true&"
import script from "./adminSupportEmailModeration.vue?vue&type=script&lang=js&"
export * from "./adminSupportEmailModeration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24da48f2",
  null
  
)

export default component.exports